/**
 * Christmas Event Assets
 */

// Gold theme Christmas assets
import goldLogoLight from './gold/logo/logo_light.svg'
import goldLogoDark from './gold/logo/logo_dark.svg'
import goldLoadingBg1 from './gold/loadingscreen/loading1_bg.jpg'

// Blue theme Christmas assets
import blueLogoLight from './blue/logo/logo_light.svg'
import blueLogoDark from './blue/logo/logo_dark.svg'
import blueLoadingBg1 from './blue/loadingscreen/loading1_bg.jpg'

// Shared decorations
import ribbonDesign from './decorations/ribbon_design.png'

// Gold theme Christmas models //

import goldChinaModel from './gold/models/china_model.png'
import goldEgyptModel from './gold/models/egypt_model.png'
import goldEnglandModel from './gold/models/england_model.png'
import goldGermanyModel from './gold/models/germany_model.png'
import goldHangsengModel from './gold/models/hangseng_model.png'
import goldIndiaModel from './gold/models/india_model.png'
import goldJapanModel from './gold/models/japan_model.png'
import goldKoreaModel from './gold/models/korea_model.png'
import goldLaosModel from './gold/models/laos_model.png'
import goldMalaysiaModel from './gold/models/malaysia_model.png'
import goldMaltaModel from './gold/models/malta_model.png'
import goldRussiaModel from './gold/models/russia_model.png'
import goldSingaporeModel from './gold/models/singapore_model.png'
import goldTaiwanModel from './gold/models/taiwan_model.png'
import goldThailandModel from './gold/models/thailand_model.png'
import goldUsaModel from './gold/models/usa_model.png'
import goldVietnamModel from './gold/models/vietnam_model.png'

export const CHRISTMAS_ASSETS = {
  gold: {
    logo: {
      light: goldLogoLight,
      dark: goldLogoDark,
    },
    loadingAssets: {
      backgrounds: {
        bg1: goldLoadingBg1,
      },
    },
    decorations: {
      ribbon: ribbonDesign,
    },
    models: {
      china: goldChinaModel,
      egypt: goldEgyptModel,
      england: goldEnglandModel,
      germany: goldGermanyModel,
      hangseng: goldHangsengModel,
      india: goldIndiaModel,
      japan: goldJapanModel,
      korea: goldKoreaModel,
      laos: goldLaosModel,
      malaysia: goldMalaysiaModel,
      malta: goldMaltaModel,
      russia: goldRussiaModel,
      singapore: goldSingaporeModel,
      taiwan: goldTaiwanModel,
      thailand: goldThailandModel,
      usa: goldUsaModel,
      vietnam: goldVietnamModel,
    } as Record<string, string>,
  },
  blue: {
    logo: {
      light: blueLogoLight,
      dark: blueLogoDark,
    },
    loadingAssets: {
      backgrounds: {
        bg1: blueLoadingBg1,
      },
    },
    decorations: {
      ribbon: ribbonDesign,
    },

    models: null as Record<string, string> | null,
  },
} as const
